export const ADMIN_ALERT = "ADMIN_ALERT"
function adminAlert(alert, id) {
  return {
    type: ADMIN_ALERT,
    payload: alert,
    id: id
  }
}

export const REMOVE_ADMIN_ALERT = "REMOVE_ADMIN_ALERT"
export function removeAdminAlert(id) {
  return {
    type: REMOVE_ADMIN_ALERT,
    id: id
  }
}

export function showNotificationWithTimeout(dispatch, alert) {
  const id = Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, "")
    .substr(0, 5)
  dispatch(adminAlert(alert, id))

  setTimeout(() => {
    dispatch(removeAdminAlert(id))
  }, 5000)
}
